<template lang="pug">
    v-navigation-drawer.navigation-drawer(
        v-if="!!currentUser && !!currentUser.account" 
        v-model='drawer' 
        app 
        clipped 
        dark
        permanent
        mini-variant-width='75'
        :mini-variant="mini"
        :expand-on-hover="mini"
        :key="mini"
    )
        div.account-name(:style="mini ? 'justify-content: start; padding: 0 20px;' : ''")
            v-subheader.white--text(v-if='!mini') {{ currentUser.account.name }}
            PinnedAccountsMenu(v-if="currentUser.activated_role_id === 1" :mini="mini")
        v-divider.ma-0(dark)
        div(v-if="!!currentUser && !!currentUser.account")
            AccountAgent(v-if="currentUser.activated_role_id === 3")
            AccountManager(v-if="currentUser.activated_role_id === 1 || currentUser.activated_role_id === 2 || currentUser.activated_role_id === 4")
            AccountSupervisor(v-if="currentUser.activated_role_id === 5")
            ClientEmployee(v-if="currentUser.activated_role_id === 6")
            OrganizationAgent(v-if="currentUser.activated_role_id === 9")
            OrganizationManager(v-if="currentUser.activated_role_id === 8")
            PurchasedListOnly(v-if="currentUser.activated_role_id === 10")
</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';

    // Components
    import AccountAgent from '@/components/shared/menu_roles/account_agent.vue';
    import AccountManager from '@/components/shared/menu_roles/account_manager.vue';
    import AccountSupervisor from '@/components/shared/menu_roles/account_supervisor.vue';
    import ClientEmployee from '@/components/shared/menu_roles/client_employee.vue';
    import OrganizationAgent from '@/components/shared/menu_roles/organization_agent.vue';
    import OrganizationManager from '@/components/shared/menu_roles/organization_manager.vue';
    import PinnedAccountsMenu from '@/components/account_switcher/pinned_accounts_menu.vue';
    import PurchasedListOnly from '@/components/shared/menu_roles/purchased_list_only.vue';

    export default Vue.extend({
        data() {
            return {
                drawer: null,
                mini: false,
            }
        },
        methods: {
            handleWindowResize() {
                if (this.$route?.meta?.forceNavbarSize?.isMini !== undefined && this.$route?.meta?.forceNavbarSize?.isMini !== null) {
                    this.mini = (this.$route.meta.forceNavbarSize.isMini || false);
                    return;
                }

                // Don't override if forceMainMenuMini is active
                if (this.forceMainMenuMini) {
                    this.mini = true;
                    return;
                }
                
                const windowWidth = window.innerWidth;
                if (windowWidth > 1200) {
                    this.mini = false;
                } else {
                    this.mini = true;
                }
            },
        },
        computed: {
            currentUser() {
                return VolieState.currentUser();
            },
            railsVolieBaseUrl() {
                return VolieState.baseRailsUrl();
            },
            forceMainMenuMini() {
                return VolieState.forceMainMenuMini();
            },
        },
        watch: {
            forceMainMenuMini(newVal) {
                if (newVal) {
                    this.mini = true;
                } else {
                    this.handleWindowResize();
                }
            },
        },
        components: {
            AccountAgent,
            AccountManager,
            AccountSupervisor,
            ClientEmployee,
            OrganizationAgent,
            OrganizationManager,
            PinnedAccountsMenu,
            PurchasedListOnly,
        },
        props: {
        },
        created() {
            window.addEventListener('resize', this.handleWindowResize);
        },
        mounted() {
            this.handleWindowResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleWindowResize);
        },
    });
</script>

<style lang="scss" scoped>
#app {
    .navigation-drawer {
        background-color: var(--volie-blue);

        .account-name {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;
        }

        .v-list-item, .v-icon {
            color: var(--white) !important;
        }
        
        .active-item {
            background-color: var(--volie-blue);
        }

        .hover-img::v-deep(.v-image__image) {
            transition: opacity 0.2s ease, transform 0.2s ease;
        }

        .hover-img:hover::v-deep(.v-image__image) {
            opacity: 0.7;
            transform: scale(1.05);
        }
    }
}
</style>
